import TextModalWithSecondary from '../../components/molecules/modals/with_secondary/text-modal-with-secondary'
import SideMenu from '../../components/organism/headers/SideMenu'

export default {
  components: {
    TextModalWithSecondary,
    SideMenu
  },
  data() {
    return {
      isModalActive: false,
      modalText: {
        title: '作成中のギフトカードがあります',
        caption:
          '作成できるカードは１つまでです。\n内容を破棄して新規作成しますか?',
        primaryButton: '新規作成する',
        secondaryButton: 'カードを確認する',
        cancelButton: '閉じる'
      },
      showableSideMenu: false
    }
  },
  methods: {
    showModal() {
      this.isModalActive = true
    },
    closeModal() {
      this.isModalActive = false
    },
    onClickPrimaryButton(url) {
      this.moveToUrl(url)
    },
    clickedSecondaryButton(url) {
      this.moveToUrl(url)
    },
    moveToUrl(url) {
      location.href = url
      this.closeModal()
    },
    toggleSideMenu() {
      this.showableSideMenu = !this.showableSideMenu
      this.toggleBodyClassList()
    },
    toggleBodyClassList() {
      document.body.classList.toggle('side-menu-active')
    }
  }
}
